export const checkFlags = (value: number, flags: number) => (value & flags) !== 0;